import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight, Sparkles } from "lucide-react";
import JanteLogo from "@/components/JanteLogo";

const SASHA_PORTRAIT =
  "https://customer-assets.emergentagent.com/job_sasha-host-flow/artifacts/gs8ak51e_image.png";

export default function MeetSasha() {
  return (
    <section
      id="meet-sasha"
      data-testid="meet-sasha-section"
      className="bg-[#FAF7F2] border-y border-[#E3DED5]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-20 lg:py-24 grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
        <motion.div
          initial={{ opacity: 0, x: -20 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
          className="lg:col-span-5 relative"
        >
          <div className="relative grain-overlay overflow-hidden">
            <div
              className="w-full h-[500px] lg:h-[560px] bg-gradient-to-b from-[#FAF7F2] to-[#F2EFE9] flex items-end justify-center relative"
              style={{
                borderTopLeftRadius: "50% 35%",
                borderTopRightRadius: "50% 35%",
              }}
            >
              <img
                src={SASHA_PORTRAIT}
                alt="Sasha — your hosting concierge"
                className="w-full h-full object-contain object-bottom"
                data-testid="sasha-portrait"
              />
            </div>
          </div>
          <div className="absolute -bottom-5 -right-5 hidden md:flex items-center gap-3 bg-[#FAF9F6] border border-[#E3DED5] px-5 py-4">
            <JanteLogo size={20} />
            <div>
              <div className="font-serif-display italic text-xl text-[#2A1F1A] leading-none">
                Sasha
              </div>
              <div className="text-[10px] uppercase tracking-[0.22em] text-[#8E8F90] mt-1">
                Your hosting concierge
              </div>
            </div>
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
          className="lg:col-span-7"
        >
          <div className="flex items-center gap-3 mb-4">
            <Sparkles size={16} className="text-[#C03028]" />
            <span className="eyebrow">Meet Sasha</span>
          </div>
          <h2
            data-testid="sasha-greeting-heading"
            className="font-serif-display text-4xl sm:text-5xl lg:text-6xl leading-[1.05] tracking-tight text-[#2A1F1A]"
          >
            &ldquo;Hello — I&apos;m Sasha,
            <br />
            <span className="italic text-[#C03028]">your hosting concierge.</span>&rdquo;
          </h2>

          <p className="mt-7 text-base lg:text-lg leading-relaxed text-[#6E6E70] max-w-xl">
            I look after the small, considered details that turn a property into
            a place guests remember. From the first inquiry to the last linen
            change — quietly, attentively, on your behalf.
          </p>

          <p className="mt-5 text-sm text-[#8E8F90] max-w-xl">
            Choose a Bronze, Silver or Gold partnership and I&apos;ll guide you
            through every step. Gold partners receive a tailored property avatar
            designed around your story.
          </p>

          <div className="mt-9 flex flex-col sm:flex-row gap-4">
            <Link
              to="/onboard"
              data-testid="sasha-cta-apply"
              className="btn-primary inline-flex items-center justify-center gap-2 px-7 py-3.5 text-sm tracking-wide rounded-none"
            >
              Begin with Sasha
              <ArrowRight size={16} />
            </Link>
            <a
              href="#service-levels"
              data-testid="sasha-cta-levels"
              className="btn-secondary inline-flex items-center justify-center gap-2 px-7 py-3.5 text-sm tracking-wide rounded-none"
            >
              See the three levels
            </a>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
